module.exports = __webpack_public_path__ + "static/chicory-5e91e3c35e68ef48ccae7b9d84f22ed4.webp";